import { STATIC_LANDING_PAGES_URLS } from "@components/utils/constants";
import { sanitizeTags } from "@components/utils/sanitizeHelpers";
import { sortPackagesAndLocations } from "@components/utils/sortingHelpers";
import { IPackageResponse } from "@customTypes/modelResponses";
import useAppContext from "@hooks/useAppContext";
import Card from "@libs/cards/Card";
import CardWrapperV2 from "@libs/cards/CardWrapperV2";
import SectionWrapper from "@modules/homePage/SectionWrapper";
import { useMemo } from "react";

interface IHomePackagesV2 {
  title: string;
  body: string;
  packages: IPackageResponse[];
}

function HomePackagesV2({
  title,
  body,
  packages,
}: IHomePackagesV2): JSX.Element {
  const { isMobile } = useAppContext();

  const cardComponents = useMemo(() => {
    return sortPackagesAndLocations(packages)
      .slice(0, isMobile ? 3 : 6)
      .map((pack) => {
        return (
          <CardWrapperV2 key={pack?.id}>
            <Card
              id={pack?.id}
              title={pack?.Title}
              blurb={pack?.Blurb}
              url={`/packages/${pack?.SEO?.Slug}`}
              tags={sanitizeTags(pack?.tags ? pack.tags : [])}
              image={pack?.PrimaryImage?.[0]}
              imageSize={"small"}
              hasLike={true}
              cardType="package"
              imageLoadingPriority={false}
            />
          </CardWrapperV2>
        );
      });
  }, [packages, isMobile]);

  return (
    <SectionWrapper
      title={title}
      body={body}
      link={STATIC_LANDING_PAGES_URLS.BEST}
      hasDots={false}
    >
      <div className={`${isMobile ? "justify-center" : "three-columns-grid"}`}>
        {cardComponents.map((card) => {
          return card;
        })}
      </div>
    </SectionWrapper>
  );
}

export default HomePackagesV2;
